import { formatNumberWithSeparators } from 'src/utils/number';

export const hasValue = (value) =>
  value !== null && value !== undefined && value !== '';

export const formatWeight = (weight, decimalSeparator, thousandsSeparator) => {
  const formattedWeight = formatNumberWithSeparators(
    weight,
    [0, 2],
    decimalSeparator,
    thousandsSeparator
  );

  return formattedWeight === 'NaN' ? weight : formattedWeight;
};

export const flattenBranches = (items, childrenField) =>
  (items || []).reduce(
    (branches, item) => [
      ...branches,
      item,
      ...flattenBranches(item?.[childrenField], childrenField),
    ],
    []
  );
